"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAMPLE_OSCE_MARKSHEET = exports.SAMPLE_TODO = exports.SAMPLE_MARKSHEET = exports.SAMPLE_CONTENT = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../fragments");
exports.SAMPLE_CONTENT = (0, client_1.gql) `
  query SampleContent {
    sampleContent {
      marksheets {
        id
        source
        mockTestId
        entitlement {
          id
          name
        }
      }
      todos {
        id
        source
      }
      osceMarksheets {
        id
        entitlement {
          id
          name
        }
        osceStation {
          id
          name
        }
      }
    }
  }
`;
exports.SAMPLE_MARKSHEET = (0, client_1.gql) `
  ${fragments_1.MARKSHEET_FIELDS}
  query SampleMarksheet($marksheetId: Int!) {
    sampleMarksheet(marksheetId: $marksheetId) {
      ...MarksheetFields
    }
  }
`;
exports.SAMPLE_TODO = (0, client_1.gql) `
  ${fragments_1.CHAPTER_FIELDS}
  ${fragments_1.PICTURE_FIELDS}
  query SampleTodo($todoId: Int!) {
    sampleTodo(todoId: $todoId) {
      id
      dailyTask
      source
      marks {
        id
        cardId
        score
        timeTaken
        card {
          question
          explanation
          concept {
            id
            name
            topic {
              id
              name
              typeId
            }
            videos {
              id
              title
              museId
              thumbnail
              concepts {
                id
                name
              }
              live
              description
              duration
            }
            chapter {
              ...ChapterFields
            }
          }
          pictures {
            ...PictureFields
          }
        }
      }
    }
  }
`;
exports.SAMPLE_OSCE_MARKSHEET = (0, client_1.gql) `
  ${fragments_1.OSCE_STATION_FIELDS}
  ${fragments_1.OSCE_MARKSHEET_FIELDS}
  query SampleOsceMarksheet($osceMarksheetId: Int!) {
    sampleOsceMarksheet(osceMarksheetId: $osceMarksheetId) {
      ...OsceMarksheetFields
      osceStation {
        ...OsceStationFields
      }
    }
  }
`;
